module.exports = __webpack_public_path__ + "media/newstyle/images/book-type-cdb9fe1d3b9546d345da2529b537b7ad.svg";